import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { CommonModule } from '@angular/common';

import { EnvironmentService } from './environment.service';

import { EnvironmentConfig } from './environment-config';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: [],
  providers: [EnvironmentService],
})
export class EnvironmentModule {
  constructor(@Optional() @SkipSelf() parentModule: EnvironmentModule) {
    if (parentModule) {
      throw new Error('EnvironmentModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(environment: unknown): ModuleWithProviders<EnvironmentModule> {
    return {
      ngModule: EnvironmentModule,
      providers: [
        {
          provide: EnvironmentConfig,
          useValue: environment,
        },
      ],
    };
  }
}
